import { DoceditorComponent } from './doceditor/doceditor.component';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './chat/chat.component';
import { CreateinvoiceComponent } from './invoice/createinvoice/createinvoice.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentComponent } from './document/document.component';
import { EmailComponent } from './email/email.component';
import { FirmProfileComponent } from './firm-profile/firm-profile.component';
import { GridComponent } from './grid/grid.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { NotesComponent } from './notes/notes.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PaymentComponent } from './payment/payment.component';
import { PracticePartnerComponent } from './firm-profile/practice-partner/practice-partner.component';
import { PreviewComponent } from './invoice/preview/preview.component';
import { RegisterComponent } from './register/register.component';
import { RelationshipComponent } from './relationship/relationship.component';
import { TimeSheetComponent } from './time-sheet/time-sheet.component';
import {groupCheckGuard} from './guards/group-check.guard'
import { AuthGuard } from './guards/auth.guard';
import { AppointmentsModule } from './appointments/appointments.moudle';
import { RegisterotpComponent } from './login/registerotp/registerotp.component';
import { FirmnameLoginComponent } from './login/firmname-login/firmname-login.component';
import { ForgotpwdComponent } from './login/forgotpwd/forgotpwd.component';
import { SubscriptionComponent } from './firm-profile/subscription/subscription.component';
import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'register', component: RegisterComponent },
  { path: 'registerotp', component: RegisterotpComponent},
  { path: 'login', component: LoginComponent },
  { path: 'firmnamelogin', component: FirmnameLoginComponent },
  { path: 'forgotpwd', component: ForgotpwdComponent },

  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: 'preview/:id', component: PreviewComponent },
      { path: 'grid', component: GridComponent },
      { path: 'doceditor', component: DoceditorComponent},
      { path: 'dashboard', component: DashboardComponent },
      { path: 'appointments', loadChildren: () => import('./appointments/appointments.moudle').then(m => m.AppointmentsModule)},
      { path: 'timesheets', loadChildren: () => import(`./time-sheet/timesheet.module`).then(m => m.TimeSheetModule) },
      { path: 'matter', loadChildren: () => import(`./matter/matter.module`).then(m => m.MatterModule)},
      { path: 'groups', loadChildren: () => import(`./groups/groups.module`).then(m => m.GroupsModule) },
      { path: 'relationship', loadChildren: () => import(`./relationship/relationship.module`).then(m => m.RelationshipModule) },
      { path: 'documents', loadChildren: () => import(`./document/document.module`).then(m => m.DocumentModule) },
      { path: 'meetings', loadChildren: () => import(`./calender/calender.module`).then(m => m.CalenderModule) },
      { path: 'audit', loadChildren: () => import(`./audit-trails/audit-trails.module`).then(m => m.AuditTrailsModule) },
      { path: 'mergepdf', loadChildren: () => import('./mergepdf/mergepdf.module').then(m => m.MergepdfModule)},
      { path: 'emails', loadChildren: () => import(`./email/email.module`).then(m => m.EmailModule) },
      { path: 'notes', component: NotesComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'chat', component: ChatComponent },
      { path: 'messages', loadChildren: () => import(`./messages/messages.module`).then(m => m.MessagesModule) },
      { path: 'profile', component: FirmProfileComponent },
      { path: 'partner', component: PracticePartnerComponent },
      { path: 'invoice', loadChildren: () => import(`./invoice/invoice-routing.module`).then(m => m.InvoiceRoutingModule) },
      { path: 'payment', loadChildren: () => import(`./payment/payment-routing.module`).then(m => m.PaymentRoutingModule) },
      { path: 'createinvoice', component: CreateinvoiceComponent },
      { path: 'subscribe', component: SubscriptionComponent }

    ]}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }